module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_harryda-17c4944d8c6f14a8e84ac9503016bc02.png";